import Api from './Api';

/**
 * Sends count w/ custom tags to our internal metrics api.
 *
 * Note: metrics fail silently
 *
 * Metrics are now allowlisted in app/models/metric.rb and need to be added
 * to the VALID_METRICS allow list in order for new metrics to appear in Datadog.
 */

const baseUrl = window.location.origin;

const sendCount = (metricName, tags = {}) => {
  Api.post(`${baseUrl}/product/metrics/count`, {
    metric_name: metricName,
    tags,
  }).then(res => res.ok);
};

const sendLog = (logContent, tags = {}) => {
  Api.post(`${baseUrl}/product/metrics/log`, {
    log_content: logContent,
    tags,
  }).then(res => res.ok);
};

export { sendCount, sendLog };
